import { render } from "./StatusField.vue?vue&type=template&id=632877cc"
import script from "./StatusField.vue?vue&type=script&lang=js"
export * from "./StatusField.vue?vue&type=script&lang=js"

import exportComponent from "/home/tobias/Desktop/screenads/nova-custom2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"StatusField.vue"]])

export default __exports__